import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import useContent from 'store/content'

import { getUserInput } from 'libs/localApi'
import Button from 'components/Button'

import { StyledLoader } from './styles'
import Input from './Input'
import AcModal from './AcModal'

const Validation = ({ appId, trigger, onSubmit, dataGa, disabled }) => {
  const [open, setOpen] = useState(false)

  const {
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    watch,
  } = useForm()

  useEffect(() => watch(), [])

  const userInputs = getUserInput(appId)

  const content = useContent()

  const onError = () => setOpen(true)

  const getInputs = () => {
    const inputs = []
    trigger.inputIds.map((inputId) => {
      inputs.push(content.get.inputById(inputId))
    })
    return inputs
  }

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      {getInputs().map((input, i) => (
        <div key={i}>
          <Input
            input={input}
            register={register}
            setValue={setValue}
            style={{ display: 'none' }}
            userInputs={userInputs}
          />

          <AcModal
            dataGa={dataGa}
            error={errors[input.name] && trigger.onTrigger.validate.inputs[input.id].errorMessage}
            inputLabel={trigger.onTrigger.validate.inputs[input.id].inputLabel}
            input={input}
            label={trigger.style.text}
            open={open}
            register={register}
            userInputs={userInputs}
            validation={trigger && trigger.onTrigger && trigger.onTrigger.validate}
          />

          <Button
            id={`${input.name} button`}
            children={
              <>
                {disabled && <StyledLoader />}
                {trigger.style.text}
              </>
            }
            type="submit"
            disabled={disabled}
          />
        </div>
      ))}
    </form>
  )
}

Validation.propTypes = {
  appId: PropTypes.string,
  dataGa: PropTypes.string,
  onSubmit: PropTypes.func,
  trigger: PropTypes.object,
  disabled: PropTypes.bool,
}

export default Validation
